import { Injectable } from '@angular/core';

import { OfferCategory } from '@cds/betting-offer';
import { EventModel } from '@frontend/sports/betting-offer/feature/model';
import { SportsCacheService } from '@frontend/sports/betting-offer/feature/sports-cache';
import { LeagueItem, isVirtualCompetitionItem } from '@frontend/sports/common/core/data-access/sport-model';
import { ComponentProxy } from '@frontend/sports/deferred/feature/component-loader';
import { Observable, map, of } from 'rxjs';

import { PopupManager } from '../../../../popup/popup-manager.service';
import { EventSwitcherComponentLoaderService, EventSwitcherEventViewBinding } from '../../../event-switcher-component-loader.service';
import { EventSwitcherTrackingService } from '../../event-switcher-tracking.service';
import { IEventSwitcherToggleHelperService } from './event-switcher-toggle-helper.service';

@Injectable()
export class EventSwitcherToggleHelperEpcotService implements IEventSwitcherToggleHelperService {
    constructor(
        private sportCacheService: SportsCacheService,
        private popupManager: PopupManager,
        private trackingService: EventSwitcherTrackingService,
        loader: EventSwitcherComponentLoaderService,
    ) {
        this.eventSwitcherComponent = loader.getEventSwitcherComponent();
    }

    eventSwitcherComponent: ComponentProxy<EventSwitcherEventViewBinding>;

    private readonly EVENT_SWITCHER_POPUP = 'event-switcher';

    openSwitcher(event: EventModel): void {
        this.eventSwitcherComponent.update({ event });

        this.popupManager.open(this.EVENT_SWITCHER_POPUP);

        this.trackingService.trackOpen(event.id);
    }

    closeSwitcher(): void {
        this.popupManager.close();
    }

    getCount(event: EventModel): Observable<number> {
        if (event.offerCategories.some((c) => [OfferCategory.Outrights].includes(c))) {
            return of(0);
        }

        return this.sportCacheService.getSport(event.sport.id, event.league.id).pipe(
            map((sport) => {
                const eventLeagueId = event.league.parentLeagueId ?? event.league.id;

                let count = sport?.children
                    .find((region) => region.id === event.region.id)
                    ?.children.find((c) =>
                        isVirtualCompetitionItem(c) && !event.league.realCompetitionId ? c.siblings.includes(eventLeagueId) : c.id === eventLeagueId,
                    );

                if (count && isVirtualCompetitionItem(count) && !event.league.realCompetitionId) {
                    count = count.children.find((c) => (<LeagueItem>c)?.siblings.includes(eventLeagueId));
                }

                return count ? count.counts.gridable : 0;
            }),
        );
    }

    get expanded$(): Observable<boolean> | undefined {
        return undefined;
    }
}
